import { zodResolver } from '@hookform/resolvers/zod'
import { cn } from '@repo/tailwind-config/tailwind.functions'
import { CoinIcon } from '@repo/ui/icons'
import { useForm } from 'react-hook-form'

import useTranslate from '../../../../../lib/hooks/use-translate'
import { ArrivalAndDepartureInput } from '../../../../../lib/types/models/arrival-and-departure/arrival-and-departure-input'
import { BaseFormProps } from '../../../../../lib/types/utils'
import { getSubmitAction } from '../../../../../lib/utils/buttons-config/validation-buttons-config'
import { FORM_MODE } from '../../../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../../../elements/forms/form'
import ControlledDateStringInput from '../../../../elements/inputs/controlled-date-string-input'
import ControlledInput from '../../../../elements/inputs/controlled-input'
import ValidationButtons from '../../../../elements/validation-buttons'
import { ARRIVAL_AND_DEPARTURE_SCHEMA_VALIDATION } from '../../utils'

type Props = BaseFormProps<ArrivalAndDepartureInput> & {
  className?: string
  country: string
}

const ArrivalAndDepartureForm = ({
  defaultValues,
  className,
  country: _country,
  ...validationButtonProps
}: Props) => {
  const { currentLanguage } = useTranslate()
  const form = useForm<ArrivalAndDepartureInput>({
    resolver: zodResolver(ARRIVAL_AND_DEPARTURE_SCHEMA_VALIDATION(currentLanguage)),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={'divide-y divide-white-active'}>
          <div className={cn('flex flex-col gap-3', className)}>
            <FormField
              control={form.control}
              name="fromTo"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledInput {...field} required label={'From / to'} type={'text'} />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="numberOfSeats"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledInput required {...field} label={'# of seats'} type={'number'} />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="cost"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledInput
                      required
                      {...field}
                      icon={CoinIcon}
                      label={'Total cost of round trip : Arrival + Departure'}
                      type={'number'}
                    />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="validUntil"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledDateStringInput {...field} mode="over" label={'Valid until'} />
                  </FormControl>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="comment"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <ControlledInput {...field} label={'Comment'} type={'textarea'} />
                  </FormControl>
                </FormItem>
              )}
            />
          </div>
          <div className="pb-6 px-4">
            <ValidationButtons {...validationButtonProps} />
          </div>
        </div>
      </form>
    </Form>
  )
}

export default ArrivalAndDepartureForm
